<template>
  <div class="has-logo">
    <logo :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :collapse="isCollapse"
        background-color="#fff"
        text-color="#222"
        active-text-color="#fff"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in menulist"
          :key="route.path"
          :item="route"
          :is-collapse="isCollapse"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SidebarItem from "./SidebarItem.vue";
import variables from "@/styles/_variables.scss";
import Logo from "./Logo.vue";
import {projectConfigDetail} from '@/utils/projectConfig.js';

export default {
  name: "SideBar",
  components: {
    SidebarItem,
    Logo,
  },
  data() {
    // 仅农博使用
    const hides = [
      {name: '属性管理', router: "/nb/goods/attr"},
      {name: '属性组管理', router: "/nb/goods/attr/group"},
      {name: '规格管理', router: "/nb/goods/sku"},
      {name: '规格组管理', router: "/nb/goods/skugroup"},
      {name: '区域简称管理', router: "/nb/goods/abbreviation"},
      {name: '商品标签管理', router: "/nb/goods/taggoods"},
      {name: '商品标签组管理', router: "/nb/goods/taggoodsgroup"},
      {name: '单位管理', router: "/nb/goods/unit"},
      {name: '品牌管理', router: "/nb/goods/brand"},
      {name: '后台类目管理', router: "/nb/goods/cat/late"},
      {name: '标签管理（旧版）', router: "/nb/goods/tag"},
      {name: '提现黑名单', router: "/finance/blacklist"},
      {name: '入场码', router: "/operation/entryCode/index"},
      {name: '签到白名单', router: "/operation/meeting/sign"},
      {name: '展会报名', router: "/nb/exhibition/apply"},
      {name: '个人主播管理', router: "/user/anchor"},
      {name: '风控黑名单列表', router: "/user/blacklistTongdun"},
      {name: '会员卡管理', router: "/user/memberShipCard"},
      {name: '票券核销查询', router: "/user/pick"}
    ];
    this.hideRoutes = hides.map(item => item.router);

    // 农博、鱼米之乡有，其他平台没有
    const others = [
      {name: '农民说管理', router: "/nb/contentManage/nombo/index"},
      {name: '农民说用户推荐管理', router: "/nb/contentManage/recommend/index"},
      {name: '话题管理', router: "/nb/contentManage/topic/index"},
      {name: '评论管理', router: "/contentManage/comment/list"},
      {name: '种草', router: "/strollnongbo/article"},
      {name: '黑名单管理', router: "/nb/contentManage/blacklist"},
    ];
    this.hideOthersRoutes = others.map(item => item.router);
    return {
      menulist: [],
    };
  },
  computed: {
    ...mapState({
      sidebar: (state) => state.app.sidebar
    }),
    routes() {
      return this.$router.options.routes;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },
  },

  mounted() {
    this.getMenuList();
  },
  methods: {
    async getMenuList() {
      const res = await this.$axios.post(this.$api.nav.getlist);
      if (res.code !== 0) return;

      let routes = res.data || [];

      if (projectConfigDetail.code !== '3300') {
        const nbGroupShow = ['企业服务', '外部应用管理', '私域工具']; // 整个模块仅农博展示
        routes = routes.filter(item => !nbGroupShow.includes(item.name));
        routes.forEach(route => {
          route.children = route.children.filter(item => !this.hideRoutes.includes(item.router));
        });
      }
      if (projectConfigDetail.code !== '3300' && projectConfigDetail.code !== '3100') {
        routes.forEach(route => {
          route.children = route.children.filter(item => !this.hideOthersRoutes.includes(item.router));
        });
      }

      this.menulist = routes;

      const routers = [];
      this.menulist.forEach(item => {
        routers.push(item.router);
        if (item.children) {
          item.children.forEach(sec => {
            routers.push(sec.router);
          });
        }
      });
      localStorage.setItem('menuPaths', JSON.stringify(routers));
    }
  },
};
</script>

<style lang="scss">
.sidebar-container {
  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }

  .scrollbar-wrapper {
    overflow-x: hidden !important;
  }

  .el-scrollbar__view {
    height: 100%;
  }

  .el-scrollbar__bar {
    &.is-vertical {
      right: 0px;
    }
    &.is-horizontal {
      display: none;
    }
  }
}
.menu-wrapper {
  .router-link-active {
    .is-active {
      background: #3bccf8 !important;
    }
  }
}
.el-menu-item:hover {
  background: #3bccf8 !important;
  color: #fff !important;
  .iconfont {
    color: #fff;
  }
}
.el-submenu__title:hover {
  background: #3bccf8 !important;
  color: #fff !important;
  .iconfont {
    color: #fff;
  }
}
.el-menu--inline {
  background: #d7f4fd !important;
}
</style>

<style lang="scss" scoped>
.has-logo {
  .el-scrollbar {
    height: calc(100% - 50px);
  }
}
.el-scrollbar {
  height: 100%;
}
.el-menu {
  border: none;
  height: 100%;
  width: 100% !important;
}
</style>
